module.exports = __webpack_public_path__ + "img/Folded_Paper_icon_dig.e24105ef.svg";